import styled from 'styled-components/macro';

export const BuyButton = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  color: #fff;
  padding: 15px 0;
  margin-top: 10px;
  cursor: pointer;
  width: 100%;
  border: 0;

  transition: background-color 0.2s;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.secondary};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const FavouriteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  width: 34px;
  height: 34px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.secondary};
  background: #fff;
  cursor: pointer;
  font-size: 1.25rem;
  line-height: 1;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }
`;

export const Container = styled.div`
  position: relative;
  text-align: left;
  box-sizing: border-box;
  padding: 16px;
  margin-bottom: 30px;
  cursor: default;
  outline: none;
  border: 1px solid ${({ theme }) => theme.colors.border};
  min-height: 420px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.secondary};
  }

  &:hover {
    border-color: rgba(238, 39, 55, 0.35);

    ${BuyButton} {
      background-color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

export const ImageFrame = styled.div`
  width: 100%;
  height: 160px;
  margin-bottom: 14px;
  background: ${({ theme }) => theme.colors.accent};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Stopper = styled.div`
  position: absolute;
  color: #fff;
  top: 10px;
  right: 10px;
  padding: 5px;
  font-size: 0.6em;
  background-color: ${({ theme }) => theme.colors.primary};
  cursor: default;
  z-index: 1;
`;

export const Title = styled.p`
  position: relative;
  padding-bottom: 14px;
  min-height: 60px;
  line-height: 1.35;

  &::before {
    content: '';
    width: 20px;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.secondary};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

export const Category = styled.p`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 0.8em;
  font-weight: bold;
  margin: 0 0 10px;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  min-height: 24px;
  margin: 0 0 15px;
`;

export const Price = styled.div`
  height: 60px;

  .val {
    b {
      font-size: 1.5em;
      margin-left: 5px;
    }
  }
`;

export const Val = styled.p`
  margin: 0;
  b {
    font-size: 1.5em;
    margin-left: 5px;
  }
`;

export const Installment = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.muted};
`;

export const Unpriced = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  font-weight: bold;
  margin: 0;
`;
